import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showMessage,isWebView } from "../../../helpers/global_helper";
import { withTranslation } from 'react-i18next';
import { getUserBalance } from "../../../redux/actions";
import { formatPrice } from "../../NumberFormat";
import { FaSyncAlt } from "react-icons/fa";
import CloseTimeAndResult from "../CloseTimeAndResult";
import festiveImg1 from "../../../assets/images/FestiveTheme/deer.svg";
import festiveImg2 from "../../../assets/images/FestiveTheme/snow-man-web.svg";
import chineseImg1 from "../../../assets/images/FestiveTheme/Flower.png";
import chineseImg2 from "../../../assets/images/FestiveTheme/FlowerOne.png";
import darkFlowerLeft from "../../../assets/images/FestiveTheme/dark_Flower_left.png";
import darkFlowerRight from "../../../assets/images/FestiveTheme/dark_Flower_right.png";
import kandliRed from "../../../assets/images/FestiveTheme/Kandil_red_left.png";
import frameImg from "../../../assets/images/FestiveTheme/Frame.png"
import lanten from "../../../assets/images/FestiveTheme/ramadan/lanten.svg";
import plusIcon from "../../../assets/images/Header/plus.svg";
import plusIconDark from "../../../assets/images/Header/plusDark.svg";
import CoachMarkPopup from "../../Popups/CoachMarkPopup";

// const DepositButton = ({ theme, depositUrl }) => {
//   return (
//     <span className='cash_DepositeIcon'>
//       <a href={depositUrl} target="_blank" rel="noopener noreferrer">
//         <img src={theme === 0 ? plusIcon : plusIconDark} alt="Deposit" />
//       </a>
//     </span>
//   );
// };

const HeaderCenterMenu = (props) => { 
  const dispatch = useDispatch();
  const device = useSelector(state => state.CommonConfig.device_type);
  const user_profile = useSelector(state => state.UserProfile);
  const user_balance = useSelector(state => state.UserBalance.user_balance);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [lastClickTime, setLastClickTime] = useState(0);
  const discountPrize = useSelector((state) => state.CommonConfig.discount);
  const game_code = useSelector((state) => state.CommonConfig.game_code);
  const currentStep = useSelector((state) => state.paginationData.currentStep)
  const theme = localStorage.getItem("theme");
  const depositUrl = sessionStorage.getItem("depositUrl");
  const [showIframe, setShowIframe] = useState(false);

  const DepositButton = ({ theme, onClick }) => {
    return (
      <span className='cash_DepositeIcon' onClick={onClick} style={{ cursor: "pointer" }}>
        <img src={theme === "0" ? plusIcon : plusIconDark} alt="Deposit" />
      </span>
    );
  };
console.log(currentStep,"cur r")

  const handleRefreshClick = () => {
    setIsRefreshing(true);
    localStorage.setItem("refBtnVal", 1);
    const currentTime = new Date().getTime();
    const newClickTime = (currentTime - lastClickTime) / 1000;
    if (newClickTime < 8) {
      const remainingTime = Math.ceil(8 - newClickTime);
      setIsRefreshing(false);
      let msgName = props.t("try_again_after_8_second");
      const myArray = msgName.split("8");
      showMessage(myArray[0] + remainingTime + myArray[1], "error", "Message");
    } else {
      dispatch(getUserBalance());
      setLastClickTime(currentTime);
    }
    setTimeout(() => {
      setIsRefreshing(false);
      localStorage.setItem("refBtnVal", 0);
    }, 1000);
  };



  return (
    <div className="header-center-menu">
      {device === "Desktop" ? (
        <>
          <div className="user_info">
            <p>
              {props.t("user")} : <span>{user_profile.nickname}</span>
            </p>
            <p>
              {props.t("balance")} :{" "}
              <span>
                {user_profile.curr}&nbsp;
                {formatPrice(user_balance.coin)}
              </span>
              <span className="refresh-icon">
                <FaSyncAlt
                  className={isRefreshing ? "refreshing" : ""}
                  onClick={handleRefreshClick}
                />
              </span>
              {/* {depositUrl && (
                <DepositButton
                  theme={theme}
                  depositUrl={depositUrl}
                  onClick={() => setShowIframe(true)}
                  className={(currentStep === 13 && depositUrl) ? "highlighted" : ""}
                />
              )} */}
              {/* {depositUrl && (
                <div className={`left-menu custom-tooltip-wrapper ${currentStep === 13 ? "highlighted" : ""}`}>
                  <DepositButton
                    theme={theme}
                    depositUrl={depositUrl}
                    onClick={() => setShowIframe(true)}
                  />
                  {currentStep === 13 && <CoachMarkPopup />}
                </div>
              )} */}
              {depositUrl && !isWebView && (
                <span
                  className={`custom-tooltip-wrapper cash_Deposite ${
                    currentStep === 13 ||
                    (device === "Mobile" && currentStep === 11)
                      ? "highlighted"
                      : ""
                  }`}
                >
                  <DepositButton
                    theme={theme}
                    depositUrl={depositUrl}
                    // onClick={() => setShowIframe(true)}
                    // onClick={() => {window.open(depositUrl, '_blank', 'width=800,height=600,noopener,noreferrer,resizable=yes,scrollbars=yes')}}
                    onClick={() => {
                      // Hardcoded desktop window size
                      const desktopWidth = 1400;
                      const desktopHeight = 650;

                      // Detect mobile device
                      const isMobile = /Mobi|Android/i.test(
                        navigator.userAgent
                      );

                      if (isMobile) {
                        // For mobile — open full screen
                        const fullWidth = window.screen.availWidth;
                        const fullHeight = window.screen.availHeight;

                        window.open(
                          depositUrl,
                          "_blank",
                          `width=${fullWidth},height=${fullHeight},left=0,top=0,resizable=yes,scrollbars=yes,noopener,noreferrer`
                        );
                      } else {
                        // For desktop — open centered window with hardcoded size
                        const screenWidth = window.screen.availWidth;
                        const screenHeight = window.screen.availHeight;

                        const left = (screenWidth - desktopWidth) / 2; // center horizontally
                        const top = (screenHeight - desktopHeight) / 2; // position around 1/3 from top

                        window.open(
                          depositUrl,
                          "_blank",
                          `width=${desktopWidth},height=${desktopHeight},left=${left},top=${top},
                          resizable=yes,scrollbars=yes,noopener,noreferrer`
                        );
                      }
                    }}
                  />
                  {(currentStep === 13 ||
                    (device === "Mobile" && currentStep === 11)) && (
                    <CoachMarkPopup />
                  )}
                </span>
              )}
              {currentStep === 13 && <div className="custom-overlay"></div>}
            </p>
            <div className="festive-image-1">
              <img src={festiveImg1} alt="" />
            </div>
          </div>

          {/* <BsTrophy className="header-icon" /> */}
          {theme == 0 ? (
            <div className="chinese-frameimg">
              <img src={chineseImg1} alt="Light Theme Image" />
            </div>
          ) : (
            <div className="chinese-frameimg">
              <img src={darkFlowerLeft} alt="Dark Theme Image" />
            </div>
          )}

          <div className="ramadan-frameimg1">
            <img src={lanten} alt="RAmadan Theme Image" />
          </div>

          {theme == 0 ? (
            <div className="chinese-flowerimg">
              <img src={frameImg} alt="Light Theme Image" />
            </div>
          ) : (
            <div className="chinese-flowerimg">
              <img src={kandliRed} alt="Dark Theme Image" />
            </div>
          )}

          <p>
            Periode : <br></br>
            {discountPrize.game_code} - {discountPrize.nextPeriode}
          </p>
          <div className="ramadan-frameimg2">
            <img src={lanten} alt="Ramadan Theme Image" />
          </div>
          <CloseTimeAndResult />
          <div className="festive-image-2">
            <img src={festiveImg2} alt="" />
          </div>
          {/* <div className="chinese-flowerimg">
              <img src={frameImg} alt="" />
          </div> */}

          {theme == 0 ? (
            <div className="chinese-flowerimg">
              <img src={frameImg} alt="Light Theme Image" />
            </div>
          ) : (
            <div className="chinese-flowerimg">
              <img src={kandliRed} alt="Dark Theme Image" />
            </div>
          )}

          {theme == 0 ? (
            <div className="chinese-frameimg">
              <img src={chineseImg2} alt="Light Theme Image" />
            </div>
          ) : (
            <div className="chinese-frameimg">
              <img src={darkFlowerRight} alt="Dark Theme Image" />
            </div>
          )}
        </>
      ) : (
        <>
          <CloseTimeAndResult />
          {theme == 0 ? (
            <div className="landscape-chinese">
              <div className="chinese-flowerimg">
                <img src={frameImg} alt="" />
              </div>
            </div>
          ) : (
            <div className="landscape-chinese">
              <div className="chinese-flowerimg">
                <img src={kandliRed} alt="Dark Theme Image" />
              </div>
            </div>
          )}

          <div>
            <p>
              {props.t("user")} : <span>{user_profile.nickname} </span>
            </p>
            <p>
              {props.t("balance")} :{" "}
              <span>
                {user_profile.curr}&nbsp;
                {/* {user_profile.curr}  */}
                {formatPrice(user_balance.coin)}
              </span>
              <span className="refresh-icon">
                <FaSyncAlt
                  className={isRefreshing ? "refreshing" : ""}
                  onClick={handleRefreshClick}
                />
              </span>
              {/* <span className="cash_DepositeIcon">

                <a href="https://tobabet.wl.hkb-gaming1.com/deposit" target="_blank" rel="noopener noreferrer">
                  {theme == 0 ? (
                    <img src={plusIcon} alt="" />
                  ) : (
                    <img src={plusIconDark} alt="" />
                  )}

                </a>
              </span> */}
              {depositUrl && !isWebView && (
                <span
                  className={`left-menu custom-tooltip-wrapper cash_DepositeIcon ${
                    currentStep === 13 ||
                    (device === "Mobile" && currentStep === 11)
                      ? "highlighted"
                      : ""
                  }`}
                >
                  <span
                    // onClick={() => setShowIframe(true)}
                    // onClick={() => {window.open(depositUrl, '_blank')}}
                    onClick={() =>
                      window.open(
                        depositUrl,
                        "_blank",
                        "width=1500,height=800,noopener,noreferrer,resizable=yes,scrollbars=yes"
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={theme === "0" ? plusIcon : plusIconDark}
                      alt="Deposit"
                    />
                  </span>

                  {(currentStep === 13 ||
                    (device === "Mobile" && currentStep === 11)) && (
                    <CoachMarkPopup />
                  )}
                </span>
              )}
            </p>
          </div>
          {(currentStep === 13 ||
            (device === "Mobile" && currentStep === 11)) && (
            <div className="custom-overlay"></div>
          )}
          {theme == 0 ? (
            <div className="landscape-chinese">
              <div className="chinese-flowerimg">
                <img src={frameImg} alt="" />
              </div>
            </div>
          ) : (
            <div className="landscape-chinese">
              <div className="chinese-flowerimg">
                <img src={kandliRed} alt="Dark Theme Image" />
              </div>
            </div>
          )}
        </>
      )}

      {showIframe && (
        <div className="iframe-modal">
          <div className="iframe-header">
            <button onClick={() => setShowIframe(false)}>Close</button>
          </div>
          <iframe
            src={depositUrl}
            title="Deposit"
            style={{ width: "100%", height: "500px", border: "none" }}
          />
        </div>
      )}
    </div>
  );
};

export default withTranslation()(HeaderCenterMenu);
